import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import { required, minLength } from 'vuelidate/lib/validators';
import * as auth from 'core/auth';
import * as api from 'core/api';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountProfilePhoneComponentModel {
    user: api.User | null;
    phone: string;
    password: string;
    submitted: boolean;
}

@WithRender
@Component({
    validations: {
        model: {
            phone: { required, minLength: minLength(5) },
            password: { required, minLength: minLength(6) }
        }
    }
})
export default class AccountProfilePhoneComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    model: AccountProfilePhoneComponentModel = {
        user: null,
        phone: '',
        password: '',
        submitted: false
    }

    mounted() {
        window.document.title = i18next.t('label_phone_mobile');

        this.loadModel();
    }

    loadModel() {
        this.$auth.getCurrentUser().then(
            (result: api.User) => {
                this.model.user = result;
                this.model.phone = this.$options.filters!.phone(this.model.user.phone);
            },
            () => {
                router.push('/signin');
            }
        );
    }

    onPhoneBlur($event) {
        this.$el.removeAttribute('placeholder');

        const v = this.$options.filters!.phone($event.target.value);

        if (v !== $event.target.value) {
            $event.target.value = this.$options.filters!.phone($event.target.value);
            this.model.phone = $event.target.value;
        }

        this.$v.model!.phone!.$touch();
    }

    onPhoneFocus() {
        this.$el.setAttribute('placeholder', '+7');
    }

    onPhoneInput($event) {
        $event.target.value = utils.String.normalizePhone($event.target.value);
        this.model.phone = $event.target.value;
    }

    onSubmit() {
        this.$v.model!.$touch();

        if (this.$v.model!.$error) {
            (<any>this.$root.$refs).messageDialog.show({
                message: i18next.t('error_fields')
            });
        } else {
            this.model.submitted = true;

            this.$auth.updatePhone(this.model.phone, this.model.password).then(
                () => {
                    this.model.submitted = false;

                    router.push('/account/profile');
                },
                (error) => {
                    this.model.submitted = false;

                    (<any>this.$root.$refs).messageDialog.show({
                        message: error?.response?.data?.message ? error.response.data.message : i18next.t('error_server_tryagain')
                    });

                    if (error.response) {
                        console.log('XHR failed', error.response.status, error.response.data);
                    } else {
                        console.log('XHR error', error.message);
                    }
                }
            );
        }
    }
}
